module.exports = __webpack_public_path__ + "img/henry-jarvis-raymond.1cf62c38.png";